/**
 * Created by litao on 2018/11/23.
 */
export default {
    data (){
        return {
            wx_appId: 'wx56de083d35e95bce',
            wx_secret: '096fdf88b33b4ed628a5be560035b335',
            wx_redirectUrlBase: 'https://lessons.e7lu.cn/h5/wx/redirect/',
            wx_responseType: 'code',
            wx_scope: 'snsapi_base',
        }
    }
}


// WEBPACK FOOTER //
// ./src/configure/warp/support/wxConfig.js